import React, { useEffect } from 'react'
import styled from 'styled-components'

import breakpoints from '../../constants/breakpoints'
import { ContentTable, Slide } from '../../types'
import { getNextSkipRoute } from '../../utils'

import SlideContainer from '../Layout/SlideContainer'
import LinkButton from '../LinkButton'
import Readspeaker from '../../components/Readspeaker'

interface Props {
  title: string
  contentTable: ContentTable[]
  button: string
  nextLink: string
  tableHeader: string[]
  routeIndex?: string
  routes: Slide[]
  onSkipRoute: (path: string) => void
}

const Table: React.FC<Props> = ({
  title,
  contentTable,
  button,
  nextLink,
  tableHeader,
  routeIndex,
  routes,
  onSkipRoute
}) => {
  useEffect(() => {
    const nextRoute = routeIndex && getNextSkipRoute(routeIndex, routes)
    nextRoute && onSkipRoute(nextRoute.path)
  }, [])

  return (
    <SlideContainer>
      <Content className="text-formatted">
        <h1>{title}</h1>
        <Readspeaker/>

        <TableContent>
          {contentTable.length > 0 &&
            contentTable.map((row: ContentTable) => (
              <Row key={row.title}>
                <Title>{row.title}</Title>
                {row.content.map((item: string, key: number) => (
                  <Div key={Math.random()}>
                    {tableHeader && <Header>{tableHeader[key]}</Header>}

                    {item}
                  </Div>
                ))}
              </Row>
            ))}
        </TableContent>

        {nextLink && (
          <Next>
            <LinkButton to={nextLink}>{button}</LinkButton>
          </Next>
        )}
      </Content>
    </SlideContainer>
  )
}

const Content = styled.div`
  max-width: 100%;

  @media (min-width: ${breakpoints.md}) {
    max-width: 1000px;
  }

  & h1 {
    text-align: center;
  }
`

const TableContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 45px;
  font-size: 18px;
  line-height: 1.61;
`

const Row = styled.div`
  display: flex;
  flex-direction: column;
  padding: 15px 8px;

  &:nth-child(even) {
    background-color: ${({ theme }) => theme.grey};
  }

  &:first-child {
    & div > div {
      display: block;
    }
  }

  @media (min-width: ${breakpoints.md}) {
    flex-direction: row;
    padding: 30px 15px;
    border-top: solid 1px ${({ theme }) => theme.lightGrey};
    border-bottom: solid 1px ${({ theme }) => theme.lightGrey};
  }
`

const Title = styled.div`
  font-weight: bold;
  margin-bottom: 25px;
  font-size: 24px;

  @media (min-width: ${breakpoints.md}) {
    width: 24%;
    padding-right: 75px;
    margin-bottom: 0;
    font-size: 18px;
    margin-top: 38px;
  }
`

const Div = styled.div`
  margin-bottom: 25px;

  @media (min-width: ${breakpoints.md}) {
    width: 38%;
    padding-right: 25px;
    margin-bottom: 0;
  }
`

const Header = styled.div`
  font-weight: bold;
  margin-bottom: 10px;

  @media (min-width: ${breakpoints.md}) {
    display: none;
  }
`

const Next = styled.div`
  width: 100%;
  max-width: 700px;
  margin: 35px auto 0;
`

export default Table
